<template>
  <div class="container">
    <div class="module_section1">
      <div class="banner_cont">
        <div class="title">EMS智慧能源管理系统</div>
        <div class="subtitle1">以“驱动低碳生活”为使命，以Energy AI为技术核心，集能源监测、智能调度、分析预测于一体的能源综合管理系统</div>
      </div>
    </div>
    <div class="module_section2 module">
      <!-- <img class="kIcon" src="https://oss.duodians.com/lambda/office_web/solution/k_icon.png" alt=""> -->
      <div class="overview_cont">
        <div class="overview_left">
          <p class="title">EMS智慧能源管理系统</p>
          <!-- <p class="subTitle">EMS智慧能源综合管理系统</p> -->
          <p class="text">实现对能源微网和光储充电站的设备数据采集和协调控制，为系统安全、稳定、高效运行提供保障，使经济效益有效提高。</p>
          <p class="text">通过Energy AI技术，对海量能源运行数据进行采集和深度分析，实现精准的需求侧响应、发电量预测、运营预测，致力于推动与实现“碳达峰、碳中和”目标。</p>
        </div>
        <div class="overview_right">
          <img src="https://oss.duodians.com/lambda/office_web/solution/section_right.png" alt="">
        </div>
      </div>
    </div>
    <div class="module_section3">
      <p class="title_com">产品优势</p>
      <div class="advantage_cont module">
        <div class="item" v-for="(el, ind) in advantageList" :key="ind">
          <img class="icon" :src="el.icon" alt="">
          <p class="title">{{ el.title }}</p>
          <p class="text">{{ el.text }}</p>
        </div>
      </div>
    </div>
    <div class="module_section4">
      <p class="title_com">组网架构</p>
      <div class="framework_cont module">
        <img src="https://oss.duodians.com/lambda/office_web/solution/framework.png" alt="">
      </div>
    </div>
    <div class="module_section5">
      <p class="title_com">产品功能</p>
      <div class="function_cont module">
        <div class="function_tab_cont">
          <div
            :class="functionActived === ind ?'actived item' : 'item'"
            v-for="(el, ind) in functionList"
            :key="ind"
            @click="handleChangeFunc(ind)"
          >
            <img class="icon" :src="el.icon" alt="">
            <p class="title">{{ el.title }}</p>
            <span v-if="functionActived === ind" class="triangle"></span>
          </div>
        </div>
        <div class="func_cont">
          <div class="func_left">
            <p class="title">
              <i></i>
              {{ functionList[functionActived].title }}
            </p>
            <p class="list_item" v-for="(e, i) in functionList[functionActived].list" :key="i">
              <i></i>
              <span>{{ e }}</span>
            </p>
          </div>
          <div class="func_right">
            <img :src="functionList[functionActived].img" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="module_section6">
      <p class="title_com">用户价值</p>
      <div class="value_cont module">
        <div class="item" v-for="(el, ind) in valueList" :key="ind">
          <img class="icon" :src="el.icon" alt="">
          <p class="title">{{ el.title }}</p>
          <p class="text">{{ el.text }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      advantageList: [{
        icon: 'https://oss.duodians.com/lambda/office_web/solution/advantage01.png',
        title: '智能化运行策略',
        text: '内置高效化的多套运行策略，可根据实际需求自动选择与切换'
      }, {
        icon: 'https://oss.duodians.com/lambda/office_web/solution/advantage02.png',
        title: '智能AI算法模型',
        text: '自学习的控制调度算法模型，适配实际环境，追求更高收益'
      }, {
        icon: 'https://oss.duodians.com/lambda/office_web/solution/advantage03.png',
        title: '电池全生命周期管理',
        text: '远程获取电池数据，为光储充生命周期保驾护航'
      }, {
        icon: 'https://oss.duodians.com/lambda/office_web/solution/advantage04.png',
        title: '丰富的API接口',
        text: '提供丰富多样的API接口实现与第三方生态伙伴的设备与系统对接'
      }, {
        icon: 'https://oss.duodians.com/lambda/office_web/solution/advantage05.png',
        title: '兼容性强',
        text: '广泛兼容市场主流光伏、储能、逆变器设备的数据对接'
      }, {
        icon: 'https://oss.duodians.com/lambda/office_web/solution/advantage06.png',
        title: '多业务场景',
        text: '灵活适用于光伏、储能、光储充一体等多种业务场景'
      }, {
        icon: 'https://oss.duodians.com/lambda/office_web/solution/advantage07.png',
        title: '云端集控',
        text: '云端+场站架构，既可以实现单场站本地部署，也可以实现站群云端管理'
      }, {
        icon: 'https://oss.duodians.com/lambda/office_web/solution/advantage08.png',
        title: '灵活配置',
        text: '可灵活按需配置功能组件，包括储能管理、光伏管理、电站管理等'
      }],
      valueList: [{
        icon: 'https://oss.duodians.com/lambda/office_web/solution/value01.png',
        title: '家庭用户',
        text: '帮助用户实现绿色能源的自发自用，节省电费，保障24小时用电需求'
      }, {
        icon: 'https://oss.duodians.com/lambda/office_web/solution/value02.png',
        title: '商业楼宇',
        text: '助力管理方全方位把控商业建筑用能监测，保障用能安全，创造高效、舒适楼宇管理体验'
      }, {
        icon: 'https://oss.duodians.com/lambda/office_web/solution/value03.png',
        title: '工厂企业',
        text: '安全生产，节能减排，提升效益，承担社会责任，树立绿色生产优质企业形象'
      }, {
        icon: 'https://oss.duodians.com/lambda/office_web/solution/value04.png',
        title: '产业园区',
        text: '提高园区供电可靠性，降低园区用能成本、提升新能源消费比例'
      }, {
        icon: 'https://oss.duodians.com/lambda/office_web/solution/value05.png',
        title: '能源投资运营商',
        text: '能源综合利用，服务用户，实现商用目标，增加收益'
      }, {
        icon: 'https://oss.duodians.com/lambda/office_web/solution/value06.png',
        title: '新能源OEM',
        text: '实现动力电池梯次利用，降低电池成本'
      }, {
        icon: 'https://oss.duodians.com/lambda/office_web/solution/value07.png',
        title: 'EPC',
        text: '配合总包单位完成客户需求，提升总包竞争力'
      }, {
        icon: 'https://oss.duodians.com/lambda/office_web/solution/value08.png',
        title: '发电侧',
        text: '平滑新能源发电，提高新能源消纳能力，减少弃风弃光'
      }],
      functionList: [{
        title: '实时数据监测',
        icon: 'https://oss.duodians.com/lambda/office_web/solution/function_icon_01.png',
        list: ['7*24小时实时精准展示市电、光伏、储能、充电桩、微网的运行数据。',
            '以多维度的数据分析与统计能源与收益数据，并可视化展示。',
            '支持场站与云端远程随时随地实时掌控电站状态。',
            '场站运行报表实时推送。'],
        img: 'https://oss.duodians.com/lambda/office_web/solution/function01.png'
      }, {
        title: '能源分析',
        icon: 'https://oss.duodians.com/lambda/office_web/energy/function_icon_01.png',
        list: ['设备全生命周期管理，分析异常点规律。',
            '数据相关性分析，找到设备、策略与能源的关系。',
            '找到能源优化点，提升能源转换效率。'],
        img: 'https://oss.duodians.com/lambda/office_web/solution/function02.jpg'
      }, {
        title: '智能预测',
        icon: 'https://oss.duodians.com/lambda/office_web/energy/function_icon_02.png',
        list: ['负荷的预测与调控。',
            '需求侧响应分析预测与管理。',
            '光伏发电预测分析。',
            '电池充放电模型分析，SOH预测。'],
        img: 'https://oss.duodians.com/lambda/office_web/solution/function03.jpg'
      }, {
        title: '高效管理',
        icon: 'https://oss.duodians.com/lambda/office_web/energy/function_icon_03.png',
        list: ['设备异常与故障及时预警通知。',
            '线上线下24小时高效运维管理。',
            '支持场集控管理，运行策略下发电站。',
            '智慧组网大屏，能源驾驶舱。'],
        img: 'https://oss.duodians.com/lambda/office_web/solution/function04.jpg'
      }],
      functionActived: 0
    };
  },
  components: {},

  computed: {},

  methods: {
    handleChangeFunc(ind) {
      this.functionActived = ind
    }
  }
};
</script>
<style lang='less' scoped>
.container{
  position: relative;
  top:-80px;
  z-index: 1;
  margin-bottom: -80px;
  .module{
    width:1300px;
    margin: 0 auto;
  }
  .title_com{
    font-size: 46px;
    font-family: PingFang SC, PingFang SC-Semibold;
    font-weight: 600;
    text-align: center;
    color: #000000;
    line-height: 66px;
    padding: 100px 0 12px;
  }
  .subTile_com{
    margin: 0 auto 0;
    width: 800px;
    height: 62px;
    opacity: 0.6;
    font-size: 16px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    text-align: center;
    color: #000000;
    line-height: 30px;
  }
  .module_section1{
    height: 630px;
    background: url('https://oss.duodians.com/lambda/office_web/solution/section1_bg.jpg');
    background-size: 100% 100%;
    .banner_cont{
      padding-top: 162px;
      .title{
        font-size: 48px;
        font-family: Source Han Sans CN, Source Han Sans CN-Bold;
        font-weight: 700;
        text-align: center;
        color: #ffffff;
        line-height: 48px;
      }
      .subtitle1{
        margin: 50px auto 0;
        width: 932px;
        font-size: 20px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        text-align: center;
        color: #ffffff;
        line-height: 30px;
      }
      .btn{
        margin: 50px auto 0;
        width: 200px;
        height: 50px;
        border: 2px solid;
        border-radius: 28px;
        border-image: linear-gradient(270deg, #4add69 18%, #4cddbd 58%, #3cecf0 43%, #12ee90 99%) 2 2;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 500;
        text-align: center;
        color: #4cddbd;
      }
    }
  }
  .module_section2{
    margin-top: -140px;
    height: 540px;
    border-radius: 30px;
    background: url('https://oss.duodians.com/lambda/office_web/solution/section2_bg.png') #f6fafd ;
    background-size: 100% 100%;
    position: relative;
    .kIcon{
      position: absolute;
      width: 131px;
      top: 74px;
      left: 120px;
    }
    .overview_cont{
      position: absolute;
      z-index: 2;
      width:980px;
      margin: 40px 0 0 170px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .overview_left{
        width:440px;
        .title{
          font-size: 36px;
          font-family: PingFang SC, PingFang SC-Medium;
          font-weight: 500;
          text-align: left;
          color: #000000;
          line-height: 34px;
        }
        .subTitle{
          font-size: 26px;
          font-family: PingFang SC, PingFang SC-Medium;
          font-weight: 500;
          color: #000000;
          line-height: 34px;
          margin-top: 14px;
        }
        .text{
          margin-top: 30px;
          font-size: 18px;
          font-family: PingFang SC, PingFang SC-Medium;
          font-weight: 500;
          text-align: justify;
          color: #000000;
          line-height: 28px;
          letter-spacing: 0.08px;
        }
      }
      .overview_right{
        img{
          width:476px;
          height: 460px;
        }
      }
    }
  }
  .module_section3{
    margin-top: 100px;
    height: 960px;
    background: #f6fafd;
    .advantage_cont{
      margin-top: 60px;
      display: flex;
      flex-wrap: wrap;
      .item{
        width: 300px;
        height: 320px;
        background: #ffffff;
        border-radius: 8px;
        margin: 0 33px 34px 0;
        padding: 40px 30px 0;
        text-align: center;
        .icon{
          width: 100px;
          height: 100px;
          margin-bottom: 25px;
        }
        .title{
          font-size: 26px;
          font-family: PingFang SC, PingFang SC-Semibold;
          font-weight: 600;
          text-align: center;
          color: #303132;
          line-height: 32px;
          margin-bottom: 5px;
        }
        .text{
          margin-top: 18px;
          font-size: 18px;
          font-family: Source Han Sans CN, Source Han Sans CN-Regular;
          font-weight: 400;
          color: #303132;
          line-height: 24px;
        }
      }
      .item:nth-child(4n) {
        margin-right: 0;
      }
    }
  }
  .module_section4{
    height: 960px;
    .framework_cont{
      img{
        margin-top: 90px;
        width:100%;
      }
    }
  }
  .module_section5{
    height: 960px;
    background: #f6fafd;
    .function_cont{
      margin-top: 80px;
      .function_tab_cont{
        display: flex;
        flex-wrap: wrap;
        .item{
          cursor: pointer;
          width: 300px;
          height: 140px;
          background: #ffffff;
          border-radius: 8px;
          margin-right: 33px;
          text-align: center;
          position: relative;
          .icon{
            width: 30px;
            height: 30px;
            margin: 34px 0 16px;
          }
          .title{
            font-size: 24px;
            font-family: PingFang SC, PingFang SC-Regular;
            font-weight: 400;
            text-align: left;
            color: rgba(0,0,0,.85);
            line-height: 30px;
            text-align: center;
          }
          .triangle{
            border: 12px solid;
            border-color: #4CDDBD transparent transparent transparent; // 
            width: 0;
            height: 0;
            display: block;
            position: absolute;
            bottom: -20px;
            left: 144px;
          }
        }
        .item.actived{
          background-image:linear-gradient(148deg,#4CDDBD, #06F286);
          .title{
            color: rgba(0,0,0);
            font-weight: 500;
            font-family: PingFang SC, PingFang SC-Medium;
          }
        }
        .item:last-child{
          margin-right: 0;
        }
      }
      .func_cont{
        margin-top: 40px;
        height: 464px;
        background: #ffffff;
        border-radius: 30px;
        padding: 40px 40px 0 80px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .func_left{
          width: 450px;
          .title{
            font-size: 26px;
            font-family: PingFang SC, PingFang SC-Medium;
            font-weight: 500;
            text-align: left;
            color: #000000;
            line-height: 37px;
            margin-bottom: 24px;
            i{
              display: inline-block;
              width: 0px;
              height: 0px;
              border: 6px solid #30cb91;
              border-color: #30cb91 #30cb91 transparent transparent;
              margin-right: 6px;
            }
          }
          .list_item{
            display: flex;
            align-items:flex-start;
            margin-bottom: 12px;
            i{
              display: inline-block;
              width: 6px;
              height: 6px;
              background: rgba(30,30,30,.5);
              margin-right: 13px;
              border-radius: 50%;
              margin-top: 10px;
            }
            span{
              display: inline-block;
              width:417px;
              font-size: 18px;
              font-family: PingFang SC, PingFang SC-Regular;
              font-weight: 400;
              text-align: justify;
              color: rgba(0,0,0,.6);
              line-height: 26px;
            }
          }
        }
        .func_right{
          img{
            width: 624px;
            height: 380px;
          }
        }
      }
    }
  }
  .module_section6{
    height: 960px;
    .value_cont{
      margin-top: 60px;
      display: flex;
      flex-wrap: wrap;
      .item{
        width: 300px;
        height: 320px;
        background: #f6fafd;
        border-radius: 8px;
        margin: 0 33px 34px 0;
        padding: 40px 30px 0;
        text-align: center;
        .icon{
          width: 100px;
          height: 100px;
          margin-bottom: 25px;
        }
        .title{
          font-size: 24px;
          font-family: PingFang SC, PingFang SC-Semibold;
          font-weight: 600;
          text-align: center;
          color: #303132;
          line-height: 32px;
          margin-bottom: 5px;
        }
        .text{
          margin-top: 18px;
          font-size: 18px;
          font-family: Source Han Sans CN, Source Han Sans CN-Regular;
          font-weight: 400;
          color: #303132;
          line-height: 24px;
        }
      }
      .item:nth-child(4n) {
        margin-right: 0;
      }
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/components/solution/solution.vue